var React = require('react');

function VerticalScrollSlideArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.9393 159.061C11.5251 159.646 12.4749 159.646 13.0606 159.061L22.6066 149.515C23.1924 148.929 23.1924 147.979 22.6066 147.393C22.0208 146.808 21.0711 146.808 20.4853 147.393L12 155.879L3.51471 147.393C2.92892 146.808 1.97917 146.808 1.39339 147.393C0.807601 147.979 0.807601 148.929 1.39339 149.515L10.9393 159.061ZM10.5 -1.03792e-07L10.5 158L13.5 158L13.5 1.03792e-07L10.5 -1.03792e-07Z","fill":"#BAE360"}));
}

VerticalScrollSlideArrow.defaultProps = {"width":"24","height":"160","viewBox":"0 0 24 160","fill":"none"};

module.exports = VerticalScrollSlideArrow;

VerticalScrollSlideArrow.default = VerticalScrollSlideArrow;
